// backend/passwords.py ile elle senkron: en az 8 karakter, bir büyük harf, bir
// küçük harf, bir rakam. Dört ekran (kayıt, ayarlar, sıfırlama, eğitmen daveti)
// aynı kuralı buradan uygular; sunucu 422 yalnızca atlatılmış formlarda görülür.
export const PASSWORD_MIN_LENGTH = 8;

export function isStrongPassword(password: string): boolean {
  return (
    password.length >= PASSWORD_MIN_LENGTH &&
    /[A-Z]/.test(password) &&
    /[a-z]/.test(password) &&
    /[0-9]/.test(password)
  );
}
